<template>
  <div class="report-partners">
    <va-card :title="$t('report-partners.cards.title')">
      <div v-if="true" class="row">
        <div class="flex md12">
          <div class="form-group mb-3">
            <va-select
              :label="$t('report-partners.forms.mesLabel')"
              v-model="mes"
              textBy="name"
              keyBy='id'
              no-clear
              :placeholder="$t('report-partners.forms.mesPlaceholder')"
              :noOptionsText="$t('report-partners.forms.mesNoOption')"
              maxHeight='200px'
              :options="optionsMes"
            />
            <va-select
              :label="$t('report-partners.forms.anosLabel')"
              v-model="ano"
              textBy="id"
              keyBy='id'
              no-clear
              :placeholder="$t('report-partners.forms.anosPlaceholder')"
              :noOptionsText="$t('report-partners.forms.anosNoOption')"
              maxHeight='200px'
              :options="optionsAno"
            />
          </div>
        </div>
      </div>
      <va-data-table
        :fields="fields"
        :data="reportPartners"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('report-partners.tooltips.see')}`" placement="bottom">
            <va-button
              flat
              icon="fa fa-eye"
              :href="`/admin/reports/partner/${props.rowData.id}` + (Object.keys(ano).length > 0 ? `/${ano.id}` + ((Object.keys(mes).length > 0 && mes.id !== null ? `/${mes.id}` : '')) : '')"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'

const perPage = 20
export default {
  name: 'reports',
  methods: {
    show () {
      if (Object.keys(this.$apollo.queries).includes('reportPartners')) {
        this.$apollo.queries.reportPartners.fetchMore({
          variables: {
            page: (this.page - 1) * this.perPage,
            perPage: this.perPage,
            mes: this.mes.id,
            ano: this.ano.id,
          },
          updateQuery: (_, { fetchMoreResult }) => {
            this.loading = false
            return fetchMoreResult
          },
        })
      } else {
        this.$apollo.addSmartQuery('reportPartners', {
          query: gql`
            query MyQuery($mes: Int!, $ano: Int!, $page: Int = 0, $perPage: Int = 2) {
              reportPartners: partners_month(args: {mes: $mes, ano: $ano}, limit: $perPage, offset: $page,) {
                id
                name
                code
                transacoes_trial
                clientes_novos
                transacoes
                somatorio_transacoes
                clicks
              }
            }
          `,
          variables: {
            perPage,
            page: 0,
            mes: this.mes.id,
            ano: this.ano.id,
          },
        })
      }
      if (Object.keys(this.$apollo.queries).includes('pages')) {
        this.$apollo.queries.pages.fetchMore({
          variables: {
            mes: this.mes.id,
            ano: this.ano.id,
          },
          updateQuery: (_, { fetchMoreResult }) => {
            this.loading = false
            return fetchMoreResult
          },
        })
      } else {
        this.$apollo.addSmartQuery('pages', {
          query: gql`
            query MyQuery($mes: Int!, $ano: Int!) {
              pages: partners_month_aggregate(args: {mes: $mes, ano: $ano}) {
                aggregate {
                  count
                }
              }
            }
          `,
          variables: {
            mes: this.mes.id,
            ano: this.ano.id,
          },
        })
      }
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.reportPartners.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
  },
  data () {
    return {
      loggedUserId: this.$store.getters['authenticate/user'].id,
      reportPartners: [],
      optionsMes: [
        {
          id: null,
          name: 'Todos',
        },
        {
          id: 1,
          name: 'Janeiro',
        },
        {
          id: 2,
          name: 'Fevereiro',
        },
        {
          id: 3,
          name: 'Março',
        },
        {
          id: 4,
          name: 'Abril',
        },
        {
          id: 5,
          name: 'Maio',
        },
        {
          id: 6,
          name: 'Junho',
        },
        {
          id: 7,
          name: 'Julho',
        },
        {
          id: 8,
          name: 'Agosto',
        },
        {
          id: 9,
          name: 'Setembro',
        },
        {
          id: 10,
          name: 'Outubro',
        },
        {
          id: 11,
          name: 'Novembro',
        },
        {
          id: 12,
          name: 'Dezembro',
        },
      ],
      mes: {},
      optionsAno: [],
      ano: {},
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
      userId: null,
    }
  },
  apollo: {
    optionsAno: {
      query: gql`
      query MyQuery {
        optionsAno: partners_years(order_by: {id: desc}) {
          id
        }
      }
      `,
      result ({
        data,
        loading,
      }) {
        if (!loading && data.optionsAno.length > 0) {
          this.ano = data.optionsAno[0]
        }
      },
    },
    // reportPartners: {
    //   query: gql`
    //   query MyQuery($page: Int = 0, $perPage: Int = 2, $busca: String = "%%", $sit: Int) {
    //     reportPartners: filter_client(
    //         args: {metodo: $sit},
    //         limit: $perPage,
    //         offset: $page,
    //         where: {_and: [{_or: [{fullName: {_ilike: $busca}}, {email: {_ilike: $busca}}]}]}
    //         order_by: {id: desc}
    //       ) {
    //       id
    //       firstName
    //       lastName
    //       email
    //       since
    //       cp: contracted_plans(where:{active:{_eq:true}}) {
    //         id
    //         plan {
    //           name
    //         }
    //         date_final
    //       }
    //       club {
    //         id
    //         name
    //       }
    //     }
    //   }
    //   `,
    //   variables () {
    //     return {
    //       perPage,
    //       page: 0,
    //       busca: this.nameSearch,
    //       sit: this.ano.id,
    //     }
    //   },
    // },
    // pages: {
    //   query: gql`
    //   query MyQuery($busca: String = "%%", $sit: Int) {
    //     pages: filter_client_aggregate(args: {metodo: $sit}, where: {_and: [{_or: [{fullName: {_ilike: $busca}}, {email: {_ilike: $busca}}]}]}) {
    //       aggregate {
    //         count
    //       }
    //     }
    //   }
    //   `,
    //   variables () {
    //     return {
    //       busca: this.nameSearch,
    //       sit: this.ano.id,
    //     }
    //   },
    // },
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      },
      {
        name: 'name',
        title: this.$t('report-partners.headings.name'),
        width: '25%',
      },
      {
        name: 'code',
        title: this.$t('report-partners.headings.code'),
        width: '25%',
      },
      {
        name: 'clientes_novos',
        title: this.$t('report-partners.headings.clientes_novos'),
        width: '15%',
      }, {
        name: 'clicks',
        title: this.$t('report-partners.headings.clicks'),
        width: '10%',
      }, {
        name: 'transacoes',
        title: this.$t('report-partners.headings.transacoes'),
        width: '15%',
        callback (value) {
          return value !== null && value.length > 0 ? value.join(', ') : ''
        },
      }, {
        name: 'somatorio_transacoes',
        title: this.$t('report-partners.headings.somatorio_transacoes'),
        width: '10%',
        callback (value) {
          return value !== null && value.length > 0 ? value.join(', ') : ''
        },
      }, {
        name: 'transacoes_trial',
        title: this.$t('report-partners.headings.transacoes_trial'),
        width: '10%',
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  watch: {
    ano (_) {
      if (Object.keys(this.ano).length > 0 && Object.keys(this.mes).length > 0) {
        this.show()
      }
    },
    mes (_) {
      if (Object.keys(this.ano).length > 0 && Object.keys(this.mes).length > 0) {
        this.show()
      }
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('reportPartners')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.reportPartners.refetch()
    }
    this.mes = this.optionsMes[new Date().getMonth() + 1]
  },
}
</script>

<style lang="scss">
</style>
